var debug = true;

function navToggle() {
  const navToggler = document.querySelector(".js-navbar-toggler");
  const navCollapse = document.querySelector(".js-mobile-nav");
  const html = document.documentElement;

  navToggler.addEventListener("click", () => {
    navCollapse.classList.toggle("show");
    navCollapse.classList.remove("show-sub");
    navCollapse.classList.remove("show-sub-sub");
    navToggler.classList.toggle("open");
    html.classList.toggle("-nav-open");
  });
}
navToggle();

/**
 * Toggle nested sub nav displays
 * Used in mobile menu and Investors sidebar nav menu
 * @param {menuSelector} - mobile or investors menu
 */
const subNavTogglers = (menuSelector) => {
  const subNavToggleMobileButtons = Array.from(
    document.querySelectorAll(menuSelector + " .js-subnav-toggle")
  );
  const investorsNav = document.querySelector(".investors-nav__outer");
  subNavToggleMobileButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      let mobNavs = Array.from(document.querySelectorAll(menuSelector));
      if (btn.classList.contains("js-subnav-toggle-0")) {
        // reset and scroll position on the investors nav
        if (investorsNav) {
          investorsNav.scrollTop = 0;
        }
        mobNavs.forEach((mobNav) => {
          mobNav.classList.toggle("show-sub");
        });
      }
      if (btn.classList.contains("js-subnav-toggle-1")) {
        mobNavs.forEach((mobNav) => {
          mobNav.classList.toggle("show-sub-sub");
        });
      }
      btn.classList.toggle("open");
      document.body.classList.toggle("-sub-nav-open");

      // bump z-index of related sub nav to be displayed
      var subNavParent = btn.parentElement;
      var child = subNavParent.childNodes[1];
      var menus = Array.from(document.querySelectorAll(".vertical.menu"));
      menus.forEach((menu) => {
        menu.classList.remove("-reveal");
      });
      child.nextElementSibling.classList.add("-reveal");
    });
  });
};
subNavTogglers(".js-investors-nav");
subNavTogglers(".js-mobile-nav");

function closeInvestorsSubNav() {
  var backToMenuBtn = document.querySelector(".js-close-sub-nav");
  var investorsNav = document.querySelector(".js-investors-nav");
  if (!backToMenuBtn) {
    return;
  }

  const resetZindexOnSubNavs = () => {
    //console.log('resetZindexOnSubNavs');
    var menus = Array.from(document.querySelectorAll(".menu"));
    menus.forEach((menu) => {
      menu.classList.remove("-reveal");
    });
  };

  backToMenuBtn.addEventListener("click", () => {
    investorsNav.classList.remove("show-sub", "show-sub-sub");
    document.body.classList.remove("-sub-nav-open");
    resetZindexOnSubNavs();
  });
}

function mobileSubNavClose() {
  const mobileMenu = document.getElementById("menu-mobile");
  if (null === mobileMenu) {
    return;
  }
  const menuBackButtons = Array.from(
    mobileMenu.querySelectorAll(".js-menu-back")
  );
  //console.log('mobtest', menuBackButtons);
  menuBackButtons.forEach((menuBackButton) => {
    menuBackButton.addEventListener("click", (e) => {
      // get closest <ul>. Is this a sub nav or sub-sub nav?
      let subNavLevel = e.currentTarget.closest("ul");
      // Get parent <ul> ie. 'sub-nv-0'
      let subNavParent = subNavLevel.closest(".js-mobile-subnav-0");
      //console.log('mobileSubNavClose', subNavLevel);
      if (subNavLevel.classList.contains("js-mobile-subnav-0")) {
        //console.log('mobileSubNavClose', 'level 0');
        mobileMenu.classList.remove("show-sub");
        document.body.classList.remove("-sub-nav-open");
        document.documentElement.classList.remove("-nav-open");
        document.querySelector(".js-navbar-toggler").classList.remove("open");
        document.getElementById("menu-mobile").classList.remove("show");
      }
      if (subNavLevel.classList.contains("js-mobile-subnav-1")) {
        //console.log('mobileSubNavClose - level 0', subNavParent);
        mobileMenu.classList.remove("show-sub-sub");
        // add '-reveal' class back to level one sub nav (sub-nav-0)
        subNavParent.classList.add("-reveal");
      }
    });
  });
}

function addParentLinksToSubMenus() {
  var mobileonlyMenu = document.querySelector(".js-mobile-nav");
  if (null === mobileonlyMenu) {
    return;
  }
  var subNavButtons = Array.from(
    mobileonlyMenu.querySelectorAll("[data-sub-nav]")
  ); // sub nav button

  subNavButtons.forEach((subNavButton) => {
    var subNavID = subNavButton.getAttribute("data-sub-nav");
    var subNavParentLink = subNavButton.getAttribute("data-sub-nav-url");

    //console.log("addParentlinksToSubMenus", subNavID);

    var subNavButtonTitle = subNavButton.innerText; // button text ie. "Responsibility"
    //var subNav = document.querySelector(`.js-mobile-subnav-${subNavID}`); // the sub nav

    var subNav = subNavButton.nextElementSibling; // the sub nav

    //console.log('addParentlinksToSubMenus', subNav);

    var arrowIcon = '<svg class="icon-arrow"><use href="#icon-arrow" /></svg>';
    var markUp =
      `<li class="menu-item__parent">` +
      `<div class="menu-item__parent-inner">` +
      `<button class="js-menu-back" aria-label="Go back">${arrowIcon}</button>` +
      `${subNavButtonTitle}` +
      `</div>` +
      `<a href="${subNavParentLink}" class="btn">Discover more</a></li>`;

    subNav.insertAdjacentHTML("afterbegin", markUp);
  });
}
addParentLinksToSubMenus();
mobileSubNavClose();

/**
 * Display sub nav when sub nav drop down button clicked
 * @returns {void}
 */
function subNavToggle() {
  const isMobile = window.matchMedia("(max-width: 1199px)");
  if (!isMobile.matches) {
    return;
  }
  const navBarNav = document.querySelector(".navbar-nav");
  navBarNav.addEventListener("click", (event) => {
    const isSubNavButton = event.target.classList.contains("dropdown-button");
    if (!isSubNavButton) {
      return;
    }
    const subNav = event.target.nextElementSibling;
    if (subNav) {
      event.target.classList.toggle("dropdown-button--rotate");
      subNav.classList.toggle("show-menu");
    }
  });
}

//@TODO: lock body scrollbar when menu is opened on mob

//subNavToggle()

const addHasChildrenClass = () => {
  // check .js-mega-col-3 and get each 'data-description[]' id
  // foreach id, check .js-mega-col-2 for a match.
  // if match exists, then items in .js-mega-col-2 are PARENTS, so add a "has-children" class
  const mega2 = document.querySelector(".js-mega-col-2");
  const mega3 = Array.from(
    document.querySelectorAll(".js-site-header .js-mega-col-3 li")
  );
  mega3.forEach((li) => {
    let dataID = li.getAttribute("data-description");
    let parent = mega2.querySelector('li[data-description2="' + dataID + '"]');
    if (null != parent) {
      parent.classList.add("has-children");
    }
  });
};
addHasChildrenClass();

closeInvestorsSubNav();
